/* Aqua Terra Backyard, All Brands behaviour.
The wall is rendered by Liquid, so every brand link is in the HTML before
this file runs and the page works with the script blocked. All this does is
filter what is already there: search, department, subcategory, letter.
Each tile carries its own handle, department index, subcategory index and
letter as data attributes, so nothing here needs a second copy of the brand
list shipped alongside the markup. */
(function(){
var R = document.querySelector(".ab2");
if(!R) return;
var N = window.__ABN__ || {d:[], s:[]};
var bar   = R.querySelector(".bar"),
wall  = R.querySelector(".wall"),
tiles = [].slice.call(wall.querySelectorAll(".bt")),
ltrs  = [].slice.call(wall.querySelectorAll(".ltr")),
feat  = R.querySelector(".feat"),
q     = R.querySelector(".abq"),
clr   = R.querySelector(".clr"),
fbtn  = R.querySelector(".fbtn"),
flab  = fbtn.querySelector(".lb"),
fpan  = R.querySelector(".filters"),
xf    = R.querySelector(".xf"),
state = R.querySelector(".state"),
az    = R.querySelector(".az"),
jz    = [].slice.call(az.querySelectorAll(".jz")),
chips = [].slice.call(R.querySelectorAll(".chip"));
var B = tiles.map(function(t){
return {t: t,
n: (t.querySelector(".bn") || {}).textContent.trim().toLowerCase(),
h: (t.getAttribute("data-h") || "").toLowerCase(),
d: t.getAttribute("data-d"),
s: t.getAttribute("data-s")};
});
var dep = "", sub = "", fam = "";
function famOf(el){ return /\be\b/.test(el.className) ? "e" : "w"; }
function shut(){
if(fpan.hidden) return;
fpan.hidden = true;
bar.className = bar.className.replace(" open", "");
fbtn.setAttribute("aria-expanded", "false");
}
function flip(){
if(!fpan.hidden){ shut(); return; }
fpan.hidden = false;
bar.className += " open";
fbtn.setAttribute("aria-expanded", "true");
}
function plural(n, w){ return n.toLocaleString() + " " + w + (n === 1 ? "" : "s"); }
function paint(){
var term = q.value.trim().toLowerCase(), shown = 0;
for(var i = 0; i < B.length; i++){
var b = B[i];
var ok = (!term || b.n.indexOf(term) > -1 || b.h.indexOf(term) > -1) &&
(dep === "" || b.d === dep) &&
(sub === "" || b.s === sub);
b.t.style.display = ok ? "" : "none";
if(ok) shown++;
}
var whole = !term && dep === "" && sub === "";
ltrs.forEach(function(l){ l.style.display = whole ? "" : "none"; });
az.hidden = !whole;
if(feat) feat.hidden = !whole;
var v = R.querySelector(".void");
if(!shown && !v){
v = document.createElement("div");
v.className = "void";
v.innerHTML = "<b>No brand under that</b><p>Try a shorter spelling, or clear the " +
"category. If it is a brand we should carry, tell us.</p>";
wall.appendChild(v);
} else if(shown && v){ v.remove(); }
var bits = [];
if(term) bits.push('matching "' + term + '"');
if(sub !== "") bits.push("in " + N.s[+sub]);
else if(dep !== "") bits.push("in " + N.d[+dep]);
state.textContent = bits.length ? plural(shown, "brand") + " " + bits.join(", ") : "";
flab.textContent = sub !== "" ? N.s[+sub] : (dep !== "" ? N.d[+dep] : "All categories");
fbtn.className = (dep !== "" || sub !== "") ? "fbtn on " + fam : "fbtn";
xf.hidden = !(dep !== "" || sub !== "");
chips.forEach(function(c){
var on = c.hasAttribute("data-d") ? (c.getAttribute("data-d") === dep)
: (c.getAttribute("data-s") === sub);
c.setAttribute("aria-pressed", String(on));
});
}
chips.forEach(function(c){
c.addEventListener("click", function(){
fam = famOf(c);
if(c.hasAttribute("data-d")){
var v = c.getAttribute("data-d");
dep = (dep === v) ? "" : v;
sub = "";
} else {
var s = c.getAttribute("data-s");
sub = (sub === s) ? "" : s;
dep = "";
shut();
}
paint();
});
});
fbtn.addEventListener("click", flip);
xf.addEventListener("click", function(){ dep = ""; sub = ""; shut(); paint(); });
document.addEventListener("click", function(e){ if(!bar.contains(e.target)) shut(); });
document.addEventListener("keydown", function(e){
if(e.key === "Escape" && !fpan.hidden){ shut(); fbtn.focus(); }
});
var tmr;
q.addEventListener("input", function(){
clr.hidden = !q.value.trim();
clearTimeout(tmr);
tmr = setTimeout(paint, 110);
});
clr.addEventListener("click", function(){ q.value = ""; clr.hidden = true; paint(); q.focus(); });
az.addEventListener("click", function(e){
var b = e.target.closest ? e.target.closest(".jz") : null;
if(!b || /\boff\b/.test(b.className)) return;
var L = b.getAttribute("data-l"), top = null;
for(var i = 0; i < ltrs.length; i++){
if(ltrs[i].getAttribute("data-l") === L){
top = ltrs[i].getBoundingClientRect().top + window.pageYOffset;
break;
}
}
if(top === null) return;
window.scrollTo({top: Math.max(0, top - bar.offsetHeight - 22), behavior: "smooth"});
});
function markLetter(){
if(az.hidden) return;
var edge = bar.getBoundingClientRect().bottom + 24, cur = null;
for(var i = 0; i < ltrs.length; i++){
if(ltrs[i].getBoundingClientRect().top > edge) break;
cur = ltrs[i].getAttribute("data-l");
}
jz.forEach(function(b){
var on = b.getAttribute("data-l") === cur;
if(on !== /\bhere\b/.test(b.className))
b.className = on ? b.className + " here" : b.className.replace(" here", "");
});
}
var head = R.querySelector(".top"), ticking = false;
function onScroll(){
var stuck = window.pageYOffset > head.offsetHeight - 6;
if(stuck !== /\bstuck\b/.test(bar.className))
bar.className = stuck ? bar.className + " stuck" : bar.className.replace(" stuck", "");
markLetter();
}
window.addEventListener("scroll", function(){
if(ticking) return;
ticking = true;
requestAnimationFrame(function(){ ticking = false; onScroll(); });
}, {passive: true});
onScroll();
var h = (location.hash || "").replace("#", "").toLowerCase();
if(h){
var hit = B.filter(function(b){ return b.h === h; })[0];
if(hit){
q.value = hit.n;
clr.hidden = false;
paint();
}
}
})();